import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-product-typing-banner',
  templateUrl: './product-typing-banner.component.html',
  styleUrls: ['./product-typing-banner.component.scss']
})
export class ProductTypingBannerComponent implements AfterViewInit {
     @Input() query = '';
  @Input() total = 0;
@ViewChild('typedText') typedText!: ElementRef;

  fullText = '';
  get displayText(): string {
    return `${this.query}`;
  }
  ngAfterViewInit() {
    this.fullText = this.displayText;
    this.typeText();
  }
    typeText() {
    const el = this.typedText.nativeElement;
    let i = 0;
    const interval = setInterval(() => {
      el.textContent += this.fullText.charAt(i);
      i++;
      if (i >= this.fullText.length) {
        clearInterval(interval);
      }
    }, 20);
  }
}
